import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { Language } from '@zep/types/common';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogPanel, DialogTitle } from '@zep/ui';
import { cn } from '@zep/utils';
import { useLocale } from '../../../../hooks';
import { Button } from '../Button';
const INQUIRY_URLS: Record<string, Record<Language, string>> = {
  zep: {
    ko: '/home/contact',
    ja: 'https://contact.zep.us/premium.plan.jp',
    en: 'https://contact.zep.us/premium.plan.en'
  },
  quiz: {
    ko: 'https://quiz.zep.us/embed/sales?type=inquiry',
    ja: 'https://quiz.zep.us/ja/embed/sales?type=inquiry',
    en: 'https://quiz.zep.us/en/embed/sales?type=inquiry'
  },
  school: {
    ko: 'https://zepschool.us/inquiry/',
    ja: 'https://zepschool.us/inquiry/',
    en: 'https://zepschool.us/inquiry/'
  }
};
const INQUIRY_BUTTONS = [{
  key: 'zep',
  labelKey: 'home:landing.chart.ctaModalButtonZep'
}, {
  key: 'quiz',
  labelKey: 'home:landing.chart.ctaModalButtonQuiz'
}, {
  key: 'school',
  labelKey: 'home:landing.chart.ctaModalButtonSchool'
}] as const;
const inquiryButtonClassName = cn('w-full h-[40px]', 'bg-quiz-violet-50 text-quiz-primary-default', 'hover:bg-quiz-violet-100', 'border border-[rgba(28,27,31,0.04)]');
type LandingInquiryModalProps = {
  onClose: () => void;
};
const LandingInquiryModal = ({
  onClose
}: LandingInquiryModalProps) => {
  const locale = useLocale();
  const {
    t
  } = useTranslation(['home']);
  const getInquiryUrl = (key: string) => {
    return INQUIRY_URLS[key]?.[locale] ?? INQUIRY_URLS[key]?.['ko'] ?? '';
  };
  const handleClickLink = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    onClose();
  };
  return <Dialog open={true} onClose={onClose} maxWidth="400px" data-sentry-element="Dialog" data-sentry-component="LandingInquiryModal" data-sentry-source-file="LandingInquiryModal.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="LandingInquiryModal.tsx" />
      <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="LandingInquiryModal.tsx">
        <DialogHeader onClose={onClose} data-sentry-element="DialogHeader" data-sentry-source-file="LandingInquiryModal.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="LandingInquiryModal.tsx">{t('home:landing.chart.ctaButton')}</DialogTitle>
        </DialogHeader>
        <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="LandingInquiryModal.tsx">
          <p className="text-quiz-body-md-regular text-quiz-default">
            {t('home:landing.chart.ctaModalDescription')}
          </p>
        </DialogContent>
        <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="LandingInquiryModal.tsx">
          <div className="flex w-full flex-col gap-quiz-xs">
            {INQUIRY_BUTTONS.map(({
            key,
            labelKey
          }) => <Button key={key} variant="contained" intent="alternative" className={inquiryButtonClassName} onClick={() => handleClickLink(getInquiryUrl(key))}>
                {t(labelKey)}
              </Button>)}
          </div>
        </DialogFooter>
      </DialogPanel>
    </Dialog>;
};
export const openLandingInquiryModal = () => {
  overlay.open(({
    close,
    unmount
  }) => <LandingInquiryModal onClose={() => {
    close();
    unmount();
  }} />);
};